import { Grid2 as Grid, Stack, Typography } from '@mui/material';
import { Dropdown } from 'framework/form';

// ToDo: temp, replace it once the full list of attributes—along with all rendering conditions—is known.
const standardAttributes = [
  { name: 'domain', label: 'Domain' },
  { name: 'object', label: 'Object' },
  { name: 'currentStates', label: 'Current states' },
  { name: 'targetStates', label: 'Target states' },
  { name: 'action', label: 'Action' },
  { name: 'sla', label: 'SLA' },
];

interface CustomAttributesProps {
  attributes: Record<string, string> | undefined;
  onAttributes: (attributes: Record<string, string>) => void;
}

export const CustomAttributes = ({ attributes = {}, onAttributes }: CustomAttributesProps) => {
  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        Custom attributes would be here. Added a few as an example for now.
      </Typography>
      <Grid container spacing={2}>
        {standardAttributes.map(({ name: attributeName, label }) => {
          const value = attributes[attributeName] ?? '';
          return (
            <Grid key={attributeName} size={{ xs: 12, sm: 6 }}>
              <Dropdown
                source={attributeName}
                label={label}
                value={value}
                options={[]}
                onChangeCallback={values => onAttributes({ ...attributes, [attributeName]: values[attributeName] })}
              />
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
};
